/* Turuq theme – global.js
   Small, dependency-free helpers: mobile drawer, slideshow,
   countdown timer, quantity steppers, product gallery thumbs. */

(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  document.querySelectorAll('[data-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = document.getElementById(btn.getAttribute('data-drawer-toggle'));
      if (!drawer) return;
      var open = drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    var dots = slideshow.querySelectorAll('.slideshow__dot');
    var autoplay = slideshow.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slideshow.getAttribute('data-speed') || '6', 10) * 1000;
    var index = 0;
    var timer = null;
    if (slides.length < 2) return;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }
    function next() { show(index + 1); }
    function start() { if (autoplay) timer = setInterval(next, speed); }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { stop(); show(n); start(); });
    });
    var prevBtn = slideshow.querySelector('[data-slide-prev]');
    var nextBtn = slideshow.querySelector('[data-slide-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); show(index - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); next(); start(); });
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    show(0);
    start();
  });

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var unitEls = {
      d: el.querySelector('[data-cd-days]'),
      h: el.querySelector('[data-cd-hours]'),
      m: el.querySelector('[data-cd-mins]'),
      s: el.querySelector('[data-cd-secs]')
    };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      if (unitEls.d) unitEls.d.textContent = pad(d);
      if (unitEls.h) unitEls.h.textContent = pad(h);
      if (unitEls.m) unitEls.m.textContent = pad(m);
      if (unitEls.s) unitEls.s.textContent = pad(s);
      if (diff <= 0) clearInterval(interval);
    }
    var interval = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var val = (parseInt(input.value, 10) || 0) + step;
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-gallery-thumb');
        if (thumb.getAttribute('data-gallery-alt')) {
          main.alt = thumb.getAttribute('data-gallery-alt');
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  });

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
})();
